import { useTranslation } from 'react-i18next';

const EarnCategory: Record<string, string> = {
  ['Staking']: 'staking',
  ['Defi']: 'defi',
  ['Lending']: 'lending',
  ['Fixed Income']: 'fixed-income',
  ['Fixed Deposit']: 'fixed-deposit',
  ['Others']: 'others'
};
// getEarnCategoryTranslationKey
export const getCategory = (category: string) => {
  const { t } = useTranslation('earn');
  if (EarnCategory[category]) {
    return t(`earn-invest::glossary.${EarnCategory[category]}`);
  }
  return category;
};

export const getEarnCategoryTranslationKey = (category: string) => {
  if (EarnCategory[category]) {
    return `earn-invest::glossary.${EarnCategory[category]}`;
  }

  return category;
};
